// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]7.1.1-11918(c826d19f07)-C10/12/2025-13:27:30-B10/12/2025-13:39:30' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]7.1.1-11918(c826d19f07)-C10/12/2025-13:27:30-B10/12/2025-13:39:30",
  branch: "production",
  latestTag: "7.1.1",
  revCount: "11918",
  shortHash: "c826d19f07",
  longHash: "c826d19f07fc33b952d7655d30000bd71c2f35a0",
  dateCommit: "10/12/2025-13:27:30",
  dateBuild: "10/12/2025-13:39:30",
  buildType: "Ansible",
  } ;
